import React, {useEffect, useState} from "react";
import {Ajax} from "../Service/ajax";
import {ClipLoader} from "react-spinners";
import {useLocation, useNavigate} from "react-router-dom";
import {convertDate} from "../config/AppConfig"
import Swal from "sweetalert2";

export default function WithdrawalCheckView(){
    const location = useLocation();
    const navigate = useNavigate();
    const success = location.state?.success;
    const error = location.state?.errors;
    const searchParams = new URLSearchParams(location.search);
    const trs=searchParams.get('trs');
    const [loading, setLoading]=useState(false);
    useEffect(() => {
        const fetchData= async ()=>{
            try {
                setLoading(true);
                const {data} =await Ajax.getRequest("/api/v1/sub/withdrawal/check/"+trs)
                console.log(JSON.stringify(data))
                if(data.error){
                    Swal.fire({
                        title: 'Error!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000,
                        timerProgressBar: true,
                        didClose: () => {
                            window.location.replace(window.location.origin+"/login");
                        }
                    });
                }else{
                    if(data.object.confirmAt !== null){
                        Swal.fire({
                            title: 'Success!',
                            text: "Retrait effectué de "+data.object.currency+""+data.object.amount+" vers "+data.object.withdrawalAccount,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            didClose: () => {
                                window.location.replace(window.location.origin+"/");
                            }
                        });
                    }
                    if(data.object.abortAt !== null){
                        Swal.fire({
                            title: 'Annulation!',
                            text: "Retrait effectué de "+data.object.currency+""+data.object.amount+" vers "+data.object.withdrawalAccount +" a été annulé avec succès",
                            icon: 'info',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            didClose: () => {
                                window.location.replace(window.location.origin+"/");
                            }
                        });
                    }
                    if(data.object.abortAt === null && data.object.confirmAt === null){
                        Swal.fire({
                            title: 'Erreur!',
                            text: "Retrait effectué de "+data.object.currency+""+data.object.amount+" vers "+data.object.withdrawalAccount +" a échoué.",
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            didClose: () => {
                                window.location.replace(window.location.origin+"/");
                            }
                        });
                    }
                }
            }catch (error){
                let errorCode;
                if (error.response) {
                    errorCode = error.response.status;
                } else {
                    errorCode = 500;
                }
                navigate('/error-page', { state: { errorCode } });
            }finally {
                setLoading(false);
            }
        }
        if(success){
            const data = JSON.parse(success);
            const {plan} = data;
            const {application} =plan;
            Swal.fire({
                title: 'Success!',
                text: "Vous venez de souscrire au pack "+plan.title+" de "+application.title +". Abonnement valide jusqu'au "+convertDate(data.endDate),
                icon: 'success',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000,
                timerProgressBar: true,
                didClose: () => {
                    window.location.replace(window.location.origin+"/");
                }
            });
        }else if(error){
            Swal.fire({
                title: 'Error!',
                text: "Une erreur s'est produite pendant la souscription à l'abonnement, veillez reessayez plus tard",
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000,
                didClose: () => {
                    window.location.replace(error);
                }
            });
        } else if (searchParams.has("trs")){
            fetchData();
        }else{
            window.location.replace(window.location.origin+"/login");
        }
    }, []);
    return(
        <div>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <ClipLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div>

                </div>
            )}
        </div>
    );
}